let store = {
    state: {
        gameList: []
    },
    setGameListAction (newVal) {
        this.state.gameList = newVal
    }
}

export default store;